export default {
  analytics: "Analitika",
  "legal-entity": "Yuridik shaxslar",
  "trading-point": "Savdo nuqtalari",
  employee: "Kassirlar",
  document: "Hujjatlar",
  tariff: "Tariflar",
  operation: "Operatsiyalar tarixi",
  "act-and-receipt": "Aktlar va hisob-fakturalar",
  manager: "Menejerlar",
  cashback: "Ballarni hisoblash",
  balance: "Balans",
  points: "Kassirlarga ballar",
  client: "Mijozlar ro‘yxati",
  spread: "RC kartalarini tarqatish",
  "wallet-pass": "Wallet karta dizayni",
  review: "Sharhlar",
  "noncash-tips": "Naqd pulsiz choychaq",
  "check-counterparties": "Kontragentlarni tekshirish",
  "push-notifications": "Wallet Push-xabarnomalari",
  "client-portrait": "Mijoz portreti",
  "active-wait": "Ballarni hisoblash (Faol kutish)",
  "e-menu": "Onlayn katalog",
  "telegram-notification": "Telegram xabarnomalari",
  faq: "FAQ",
  terminal: "Processing",
  promotion: "Aksiyalar",
  cashback_group: "Ballarni hisoblash (Mijozlar guruhlari)",
  payment_info: "To‘lov usullari",
  orders: "Buyurtmalar / RC PAY menyusi",
  "trading-point-promotion": "Rivojlantirish",
  "gift-card": "Sovg‘a kartalari",
  "kassa-orders": "Buyurtmalar / RC KASSA katalogi",
  "partner-profile": "Hamkor profili",
};
